import * as moment from 'moment';
import * as env from '../env';

export interface HttpResponse {
    status: number;
    statusText: string;
    headers: Headers;
    data?: object | string;
}

function isValidDate(d: any): boolean {
    if (moment.isMoment(d)) {
        return true;
    }
    const date = new Date(d);
    return typeof (d) === 'string' && date instanceof Date && !isNaN(<number><any>date) && isNaN(Number(d));
}

function sanitizeDates(obj: any): any {
    if (!obj) {
        return obj;
    }
    const result = {};
    Object.keys(obj).forEach(prop => {
        const value = obj[prop];
        if (moment.isMoment(value)) {
            result[prop] = moment(value).format();
        }
        else if (typeof (value) === 'object') {
            result[prop] = sanitizeDates(value);
        } else if (isValidDate(value)) {
            result[prop] = moment(value).format();
        } else {
            result[prop] = value;
        }
    });
    return result;
}

function request(method: string, url: string, data?: any, headers: Headers = new Headers()): Promise<HttpResponse> {
    // Get token from local storage
    const accessToken = localStorage.getItem('token');
    let requestData = data;

    // Append/overwrite authorization header
    if (accessToken) {
        headers.append('Authorization', `Bearer ${accessToken}`);
    }

    if (requestData) {
        if (requestData instanceof URLSearchParams) {
            headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
            requestData = requestData.toString();
        } else {
            headers.append('Content-Type', 'application/json');
            //  requestData = JSON.stringify(sanitizeDates(requestData.data)); // TODO: Make sure sagas extract the data from action and then change this
            // requestData = JSON.stringify(sanitizeDates(requestData)) // How it actually should be.
            requestData = JSON.stringify(requestData);
        }
    }

    // Initialize request, enforce CORS
    let httpRequest: RequestInit = { method, headers };

    // Append data to request if any
    if (data) { httpRequest = { ...httpRequest, body: requestData }; }

    // fetch from api url
    return fetch(env.apiBaseUrl + url, httpRequest)
        .then(async res => {
            // initialize result
            const result: HttpResponse = {
                status: res.status,
                statusText: res.statusText,
                headers: res.headers,
            }
            // read the result as text
            const text = await res.text();

            try {
                // Assume result was JSON and parse it
                result.data = JSON.parse(text);
            } catch {
                // catch parse error to set result data as text
                result.data = text;
            }


            if (result.status === 401) {
                // if the result was "401 Unauthorized", remove saved token and navigate to login.
                localStorage.removeItem('token');
                window.location.href = '/login';
            } else if (result.status === 403) {
                // if the result was "403 Forbidden", navigate to front page
                window.location.href = '/';
            }

            return result;
        });
};

export default {
    get: (url: string, headers?: Headers): Promise<HttpResponse> => request('GET', url, null, headers),
    post: (url: string, data?: any, headers?: Headers): Promise<HttpResponse> => request('POST', url, data, headers),
    put: (url: string, data?: any, headers?: Headers): Promise<HttpResponse> => request('PUT', url, data, headers),
    delete: (url: string, data?: any, headers?: Headers): Promise<HttpResponse> => request('DELETE', url, data, headers),
    patch: (url: string, data?: any, headers?: Headers): Promise<HttpResponse> => request('PATCH', url, data, headers)
};



// WEBPACK FOOTER //
// ./src/utils/api.ts